import {createI18n} from 'vue-i18n'

import au from '/src/lang/au.json';
import en from '/src/lang/en-US.json';
import gm from '/src/lang/gm.json';
import ja from '/src/lang/ja.json';
import ko from '/src/lang/ko.json';
import ru from '/src/lang/ru.json';
import th from '/src/lang/th.json';
import zh_CN from '/src/lang/zh_CN.json';
import zh_Hant from '/src/lang/zh_Hant.json';
import fr from '/src/lang/fr.json';
import es from '/src/lang/es.json';
import vi from '/src/lang/vi.json';



import util from "@/common/util";
import config from "@/common/api/config";

// 默认语言设置为英文
const lang = util.getCache('lang') ? util.getCache('lang'): 'en-US' ;

export default createI18n({
    legacy: true, // 让 setup 函数可以通过 t 访问
    globalInjection: true, // 让 template 可以像 vue2 那样使用 $t 来访问
    locale: lang ? lang : 'en-US',
    fallbackLocale: 'en-US', // 回退语言设置为英文
    messages: {
        'au': au,
        'en-US': en,
        'gm': gm,
        'ja': ja,
        'ko': ko,
        'ru': ru,
        'th': th,
        'zh_CN': zh_CN,
        'zh_Hant': zh_Hant,
        'fr': fr,
        'es': es,
        'vi': vi,
    }
})
